import { Component, Vue, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import FontAwesomeIcon from '@/components/icons/font-awesome-icon/font-awesome-icon';
import { Drag, Drop } from 'vue-drag-drop';
import { competencyModelAPI } from '@/providers/apis/competency-model/competency-model';
import { sessionService } from '@/providers/services/auth/session';

@Component({
  name: 'file-version',
  components: {
    'material-icon': GoogleMaterialIcon,
    'font-awesome': FontAwesomeIcon,
  },
})
export default class FileVersion extends Vue {
  @Prop({default: null})
  private selectedCompetency: any;
  private session: any = null;
  private userId: any = null;
  private tenantId: any = null;
  private fileList: any = [];
  private inUseFile: any = null;

  // -----------------------------------------------------------------------
  // Actions

  private onGoBack(data: any) {
    this.$emit('onGoBack', false);
  }

  // ------------------------------------------------------------------------
  // Hooks

  private created() {
    window.scrollTo(0, 0);
    this.session = sessionService.getSession();
    this.userId = this.session.user_id;
    this.tenantId = this.session.tenant.tenant_id;
    this.fetchFileVersions(this.selectedCompetency.id);
  }

  // --------------------------------------------------------------------------
  // Methods
  private fetchFileVersions(id: any) {
    competencyModelAPI.fetchFileVersionById(id).then((res) => {
      this.fileList = res.filesList;
      for (const item of res.filesList) {
        if (item.inUse) {
          this.inUseFile = item;
        }
      }
    });
  }
  private preview(version: any) {
    competencyModelAPI.previewFileVersionById(version.id).then((res) => {
      this.fetchFileVersions(this.selectedCompetency.id);
    });
  }
}
